<div>
  <h1>{{ title | translate}}</h1>
  @if (text) {
  <p>{{text | translate}}</p>
  }
</div>